<template>
    <div class="sustainable-component sustainable-component-scrollable work-organisation">
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div v-html="$t('workorganisation_tab3_tool_describe_tasks_text')"></div>
                    <div data-testid="work-content-job-position-field" :data-active-job-position-id="activeJobPositionIdAttr">
                        <v-select :key="'work-content-position-select-' + jobPositionSelectKey" data-testid="work-content-job-position-select" :data-active-job-position-id="activeJobPositionIdAttr" bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="jobPositionItems" v-model="selectedPosition" item-title="Name" item-value="JobPositionId" :item-props="workContentJobPositionItemProps"></v-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <v-btn v-bind:disabled="disabled" data-testid="job-task-add-button" v-if="enableRegulation == false" size="default" color="primary" class="btn-primary mb-5" @click="addJobPositionTask">
                        {{$t('workorganisation_tab3_tool_describe_tasks_add_task_button')}}
                    </v-btn>
                </div>
                <div class="col-6" style="text-align:right">
                    <v-btn v-bind:disabled="disabled" v-if="enableRegulation == false" size="default" color="primary" class="btn-primary mb-5" @click="addJobPositionSuggestion">
                        {{$t('workorganisation_tab3_tool_describe_tasks_add_suggestion_button')}}
                    </v-btn>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="table-responsive">
                        <table data-testid="job-task-table" class="table table-light table-hover table-striped worktable" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                            <colgroup>
                                <col style="width:44px" />   <!-- meny -->
                                <col style="width:45%" />    <!-- position -->
                                <col />                      <!-- utbildning/krav (tar resten) -->
                                <col style="width:34px" />   <!-- kommentar -->
                            </colgroup>

                            <thead>
                                <tr>
                                    <th class="col-1"></th>
                                    <th class="col-5 ellipsis first">{{$t('general.workorganisation_general_position')}}</th>
                                    <th class="col-5 ellipsis">{{$t('general.workorganisation_general_education_and_requirements')}}</th>
                                    <th class="col-1"></th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in jobPositionTasks"
                                    :key="index"
                                    :data-testid="item.Id ? `job-task-row-${item.Id}` : null"
                                    :data-job-task-name="item.Name">
                                    <td class="col-1">
                                        <v-menu location="bottom end">
                                            <template #activator="{ props }">
                                                <a href="#"
                                                   class="drop"
                                                   :data-testid="item.Id ? `job-task-menu-trigger-${item.Id}` : null"
                                                   v-bind="props"
                                                   @click.prevent>...</a>
                                            </template>

                                            <v-list density="compact">
                                                <v-list-item :data-testid="item.Id ? `job-task-edit-${item.Id}` : null" title="Ändra" @click="changeJobPositionTask(item)" />
                                                <v-list-item title="Kopiera till förslag" @click="copyJobPositionTaskToSuggestion(item.Id)" />
                                                <v-list-item :data-testid="item.Id ? `job-task-delete-${item.Id}` : null" title="Ta bort" @click="deleteJobPositionTask(item.Id)" />
                                            </v-list>
                                        </v-menu>

                                    </td>

                                    <td class="col-6 ellipsis first">
                                        <span v-if="selected != item" v-html="item.Name"></span>
                                    </td>
                                    <td class="col-5 ellipsis">
                                        <span v-if="selected != item" v-html="item.EducationAndRequirements"></span>
                                    </td>
                                    <td class="col-1">
                                        <span v-if="item.Comments != null && item.Comments != ''" style="position:relative"><i style="position:absolute; margin-top:5px" class="mdi mdi-message-outline"></i></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                  
                </div>
                <div class="col-12 col-md-6">
                    <div class="table-responsive">
                        <table class="table table-light table-hover table-striped worktable" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse; width:100%">
                            <colgroup>
                                <col style="width:44px" />   <!-- meny -->
                                <col style="width:45%" />    <!-- förslag -->
                                <col />                      <!-- utbildning/krav -->
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="col-1"></th>
                                    <th class="col-6 ellipsis first">
                                        <span class="d-block d-md-none">Bef. förslag</span>
                                        <span class="d-none d-md-block">Befattningsförslag</span>
                                    </th>
                                    <th class="col-5 ellipsis">{{$t('general.workorganisation_general_education_and_requirements')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in internalModel.JobTaskSuggestions" :key="index">
                                    <td class="col-1">
                                        <div class="pull-right" v-if="disabled == false">
                                            <v-menu location="bottom end">
                                                <template #activator="{ props }">
                                                    <a href="#" class="drop text-right pr-2" v-bind="props" @click.prevent>...</a>
                                                </template>

                                                <v-list density="compact">
                                                    <v-list-item title="Använd" @click="applyJobPositionSuggestion(item.Name, item.EducationAndRequirements)" />
                                                    <v-list-item title="Ta bort" @click="deleteJobPositionSuggestion(item.Id)" />
                                                    <v-list-item title="Ändra" @click="changeJobPositionTaskSuggestion(item)" />
                                                </v-list>
                                            </v-menu>
                                        </div>
                                    </td>
                                    <td class="col-6 ellipsis first">
                                        <span v-bind:disabled="disabled" v-if="selected != item" v-html="item.Name"></span>
                                    </td>
                                    <td class="col-5 ellipsis">
                                        <span v-bind:disabled="disabled" v-if="selected != item" v-html="item.EducationAndRequirements"></span>
                                    </td>

                                </tr>
                            </tbody>
                        </table>


                    </div>
                  
                </div>
            </div>
        </div>
        <UpdateWorktask ref="workdialog" v-bind:disabled="disabled" @taskupdated="updatedWorkDialog" @suggestionupdated="suggestionupdated"></UpdateWorktask>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>



<script>

    import ValidationService from "../../Services/ValidationService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import UpdateWorktask from "./update-worktask.vue";
    import { ref } from 'vue'
    const form = ref(null);
    const workdialog = ref(null);

    export default {

        name: 'work-organisation',
        emits: ['positionSelected', 'position-selected'],
        props: {
            model: Object,
            selectedJobPosition: [String, Number],
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components:{
            UpdateWorktask,
            CommonSpinner,
        },
        methods: {
            syncJobPositionFieldsFromApi(row) {
                if (!row || typeof row !== 'object') {
                    return;
                }
                if (row.Name === undefined && row.name !== undefined) {
                    row.Name = row.name;
                }
                if (row.JobPositionId === undefined && row.jobPositionId !== undefined) {
                    row.JobPositionId = row.jobPositionId;
                }
            },
            jobPositionId(row) {
                if (!row) {
                    return null;
                }
                var id = row.JobPositionId !== undefined ? row.JobPositionId : row.jobPositionId;
                return id === undefined || id === null ? null : id;
            },
            jobPositionDisplayName(row) {
                if (!row) {
                    return '';
                }
                return row.Name !== undefined ? row.Name : row.name || '';
            },
            debugWorkOrganisationFlow(eventName, payload) {
                try {
                    var enabled = window.location.hostname === 'localhost'
                        || window.location.hostname === '127.0.0.1'
                        || window.localStorage.getItem('swc.workOrganisation.debug') === 'true';
                    if (!enabled) {
                        return;
                    }
                    console.debug('[SWC WorkOrganisation]', 'work-content:' + eventName, payload || {});
                }
                catch (error) {
                    // Ignore diagnostics failures.
                }
            },
            summarizeJobPositions(jobPositions) {
                if (!Array.isArray(jobPositions)) {
                    return { count: 0, first: [] };
                }
                var self = this;
                return {
                    count: jobPositions.length,
                    first: jobPositions.slice(0, 5).map(function (p) {
                        return {
                            id: self.jobPositionId(p),
                            name: self.jobPositionDisplayName(p),
                        };
                    }),
                };
            },
            syncJobPositionsFromModel() {
                this.internalModel = this.model;
                var list = this.internalModel && this.internalModel.JobPositions;
                if (!Array.isArray(list)) {
                    this.debugWorkOrganisationFlow('syncJobPositionsFromModel:no-list', {
                        selectedJobPosition: this.selectedJobPosition,
                        selectedPosition: this.selectedPosition,
                    });
                    return;
                }
                for (var i = 0; i < list.length; i++) {
                    this.syncJobPositionFieldsFromApi(list[i]);
                }
                this.debugWorkOrganisationFlow('syncJobPositionsFromModel', {
                    selectedJobPosition: this.selectedJobPosition,
                    selectedPosition: this.selectedPosition,
                    jobPositionSelectKey: this.jobPositionSelectKey,
                    jobPositions: this.summarizeJobPositions(list),
                });
            },
            workContentJobPositionItemProps(item) {
                var raw = item && item.raw !== undefined ? item.raw : item;
                if (!raw || raw.JobPositionId === undefined || raw.JobPositionId === null) {
                    return {};
                }
                var id = raw.JobPositionId;
                if (id <= 0) {
                    return {};
                }
                return {
                    'data-testid': 'work-content-job-position-option-' + id,
                };
            },
            setSelectedJobPositionFromProp(newVal) {
                if (newVal == null || newVal === "") {
                    return;
                }
                var asNumber = Number(newVal);
                var id = Number.isNaN(asNumber) ? newVal : asNumber;
                if (this.selectedPosition !== id) {
                    this.debugWorkOrganisationFlow('setSelectedJobPositionFromProp', {
                        incoming: newVal,
                        normalized: id,
                        previousSelectedPosition: this.selectedPosition,
                    });
                    this.selectedPosition = id;
                }
            },
            ensureSelectedPositionMatchesVisibleItem() {
                if (this.selectedJobPosition != null && this.selectedJobPosition !== '') {
                    this.setSelectedJobPositionFromProp(this.selectedJobPosition);
                    return;
                }
                if (this.jobPositionItems.length > 0) {
                    var first = this.jobPositionItems[0];
                    var id = first && first.JobPositionId !== undefined ? first.JobPositionId : first && first.jobPositionId;
                    if (id !== undefined && id !== null && id !== '') {
                        this.setSelectedJobPositionFromProp(id);
                    }
                }
                this.debugWorkOrganisationFlow('ensureSelectedPositionMatchesVisibleItem', {
                    selectedJobPosition: this.selectedJobPosition,
                    selectedPosition: this.selectedPosition,
                    jobPositions: this.summarizeJobPositions(this.jobPositionItems),
                });
            },
            async getWorkTasks(id) {
                this.loading++;
                this.debugWorkOrganisationFlow('getWorkTasks:start', {
                    id: id,
                    selectedJobPosition: this.selectedJobPosition,
                    selectedPosition: this.selectedPosition,
                });
                try {
                    this.jobPositionTasks = await WorkOrganisationService.getJobPositionWorkTasks(id);
                    this.debugWorkOrganisationFlow('getWorkTasks:done', {
                        id: id,
                        selectedPosition: this.selectedPosition,
                        taskCount: Array.isArray(this.jobPositionTasks) ? this.jobPositionTasks.length : 0,
                    });
                }
                catch (error) {
                    this.debugWorkOrganisationFlow('getWorkTasks:error', {
                        id: id,
                        message: error && error.message ? error.message : String(error),
                    });
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            addJobPositionTask() {
                this.loading++;
                try {
                    this.ensureSelectedPositionMatchesVisibleItem();
                    this.workdialog.createTask(this.selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            addJobPositionSuggestion() {
                this.loading++;
                try {
                    this.workdialog.createSuggestion();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            changeJobPositionTask(jobPositionTask) {
                this.loading++;
                this.workdialog.openTask(jobPositionTask)
                this.loading--;
            },
            changeJobPositionTaskSuggestion(jobPositionTaskSuggestion) {
                this.loading++;
                this.workdialog.openSuggestion(jobPositionTaskSuggestion)
                this.loading--;
            },
            async applyJobPositionSuggestion(name, education) {
                this.loading++;
                try {
                    this.ensureSelectedPositionMatchesVisibleItem();
                    await WorkOrganisationService.addJobPositionTask(this.selectedPosition, name, education)
                    this.displaySnackBar("Sparat");
                    this.getWorkTasks(this.selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            
            async deleteJobPositionSuggestion(id) {
                if (confirm("Är du säker på att du vill radera arbetsuppgiften från uppgiftslistan med förslag?")) {
                    this.loading++;
                    try {
                        await WorkOrganisationService.deleteJobPositionWorkTaskSuggestion(id);
                        this.displaySnackBar("Borttaget");
                        this.internalModel.JobTaskSuggestions = await WorkOrganisationService.getWorkSuggestions();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },  
            async deleteJobPositionTask(id) {
                if (confirm("Är du säker att du vill radera arbetsuppgiften?")) {
                    this.loading++;
                    try {
                        await WorkOrganisationService.deleteJobPositionWorkTask(id);
                        this.displaySnackBar("Borttaget");
                        this.getWorkTasks(this.selectedPosition);
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async copyJobPositionTaskToSuggestion(taskId) {
                this.loading++;
                try {
                    await WorkOrganisationService.copyJobPositionTaskToSuggestion(taskId);
                    this.displaySnackBar("Sparad");
                    this.internalModel.JobTaskSuggestions = await WorkOrganisationService.getWorkSuggestions();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            updatedWorkDialog(savedTask) {
                this.loading++;
                try {
                    if (savedTask && savedTask.Id > 0) {
                        var taskIndex = this.jobPositionTasks.findIndex(function (task) {
                            return task && task.Id === savedTask.Id;
                        });
                        if (taskIndex >= 0) {
                            this.jobPositionTasks.splice(taskIndex, 1, savedTask);
                        }
                        else {
                            this.jobPositionTasks.push(savedTask);
                        }
                    }
                    this.getWorkTasks(this.selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async suggestionupdated() {
                this.loading++;
                try {
                    this.internalModel.JobTaskSuggestions = await WorkOrganisationService.getWorkSuggestions();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        computed: {
            jobPositionItems() {
                var list = this.internalModel && Array.isArray(this.internalModel.JobPositions)
                    ? this.internalModel.JobPositions
                    : [];
                var selectedId = Number(this.selectedJobPosition || this.selectedPosition);
                if (Number.isNaN(selectedId) || selectedId <= 0) {
                    return list;
                }

                var selected = [];
                var rest = [];
                for (var i = 0; i < list.length; i++) {
                    var row = list[i];
                    var id = row && row.JobPositionId !== undefined ? row.JobPositionId : row && row.jobPositionId;
                    if (Number(id) === selectedId) {
                        selected.push(row);
                    }
                    else {
                        rest.push(row);
                    }
                }

                return selected.concat(rest);
            },
            activeJobPositionIdAttr() {
                var v = this.selectedPosition;
                if (v === null || v === undefined || v === '') {
                    return '';
                }
                var n = Number(v);
                if (!Number.isNaN(n) && n > 0) {
                    return String(n);
                }
                return '';
            },
        },
        data() {
            return {
                rules: ValidationService.rules(),
                internalModel:{
                    JobPositions: [],
                    JobTaskSuggestions: [],
                },
                jobPositionTasks: [],
                jobPositionName: '',
                jobBlockName: '',
                jobBlockNumber: -1,
                selectedPosition: null,
                initialSelectionComplete: false,
                jobPositionSelectKey: 0,
                enableRegulation: false,
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                if (newVal === null || newVal === undefined || newVal === '') {
                    return;
                }
                this.debugWorkOrganisationFlow('watch:selectedPosition', {
                    newVal: newVal,
                    selectedJobPosition: this.selectedJobPosition,
                    initialSelectionComplete: this.initialSelectionComplete,
                    jobPositions: this.summarizeJobPositions(this.jobPositionItems),
                });
                if (!this.initialSelectionComplete
                    && this.selectedJobPosition != null
                    && this.selectedJobPosition !== ''
                    && Number(newVal) !== Number(this.selectedJobPosition)) {
                    this.setSelectedJobPositionFromProp(this.selectedJobPosition);
                    return;
                }
                this.getWorkTasks(newVal);
                this.$emit('positionSelected', newVal);
                this.$emit('position-selected', newVal);
            },
            selectedJobPosition: {
                handler: function (newVal) {
                    this.debugWorkOrganisationFlow('watch:selectedJobPosition', {
                        newVal: newVal,
                        selectedPosition: this.selectedPosition,
                    });
                    this.setSelectedJobPositionFromProp(newVal);
                },
            },
            'model.JobPositions': function (newList, oldList) {
                if (newList !== oldList) {
                    this.syncJobPositionsFromModel();
                    this.jobPositionSelectKey++;
                    this.debugWorkOrganisationFlow('watch:model.JobPositions', {
                        jobPositionSelectKey: this.jobPositionSelectKey,
                        selectedJobPosition: this.selectedJobPosition,
                        selectedPosition: this.selectedPosition,
                        jobPositions: this.summarizeJobPositions(newList),
                    });
                }
            },
        },
        created() {
            this.syncJobPositionsFromModel();
            this.setSelectedJobPositionFromProp(this.selectedJobPosition);
        },
        mounted() {
            this.syncJobPositionsFromModel();
            this.setSelectedJobPositionFromProp(this.selectedJobPosition);
            var self = this;
            this.$nextTick(function () {
                self.initialSelectionComplete = true;
            });
        },
        setup() {
            return { workdialog, form }
        }
    }
</script>

<style scoped>

    .worktable {
        table-layout: fixed; /* gör att colgroup verkligen styr */
        width: 100%;
    }

        .worktable th,
        .worktable td {
            vertical-align: top;
        }

        /* gör ellipsis korrekt i fixed-table */
        .worktable .ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 0; /* viktigt i table-layout: fixed */
        }
</style>
